// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"a5af56ac","124":"f096ccb7","164":"cfd95337","296":"00cdcf7b","330":"6b09776a","453":"4fbad7c7","501":"1ca094cf","656":"03c6a7e1","898":"0a4ad88d","948":"e9a5c4f3","956":"270d1e32"}[chunkId] + ".chunk.js";
};